import { useQuery } from '@tanstack/react-query';
import { SessionRosterEntry, telemetryService } from '../services/telemetry/telemetryService';

export const useSessionRoster = (sessionId: string | null) => {
  return useQuery<SessionRosterEntry[]>({
    queryKey: ['session', 'roster', sessionId],
    queryFn: async () => {
      if (!sessionId) return [];
      return telemetryService.getSessionRoster(sessionId);
    },
    enabled: !!sessionId,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};
